module.exports = __webpack_public_path__ + "static/media/a.befeaf14.png";